// extracted by mini-css-extract-plugin
export var smallSpinner = "_wz-0";